import React from "react";
import "../../Styles/yellowcalf.css/Fee_Due_for_Siblings.css";

function Fee_Due_for_Siblings() {
  return (
    <div className="fee-due-container" style={{paddingTop:"25px"}}>
      
      <div className="fee-due-header">
        <h3>Fee Due for Siblings</h3>
        <div className="export-btn-container">
          <button className="export-btn-siblings">
            Export <span className="arrow-down"></span>
          </button>
        </div>
      </div>

      {/* Filter + Table Section */}
      <div className="fee-due-body">
        <div className="filter-section">
          <select className="parent-select">
            <option value="">Select Parent</option>
          </select>
          <button className="search-btn-fee">Search</button>
        </div>

        {/* Table */}
        <div className="table-container">
          <table className="fee-table">
            <thead>
              <tr>
                <th>Sr No</th>
                <th>Grade</th>
                <th>Division</th>
                <th>Total Amount Paid</th>
                <th>Balance</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="6" className="no-results">
                  No results found.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Fee_Due_for_Siblings;
